import { FC } from 'react';
import Alert from '@mui/material/Alert/Alert';
import { useTranslation } from 'react-i18next';


const ReferAlert : FC = () => {

    const { t } = useTranslation()

    return <Alert>{t('refer.alert')}</Alert>
 
}

export default ReferAlert